if (!window.FreeGiftsRandomizer) {
  window.FreeGiftsRandomizer = new function () {
    var storageKey = 'swan-island-product-display-seed-v2';
    var fallbackSeed;
    var api = this;

    function getSeed() {
      try {
        var storedSeed = window.sessionStorage.getItem(storageKey);
        if (storedSeed) {
          return storedSeed;
        }
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        var newSeed = values[0].toString(36);
        window.sessionStorage.setItem(storageKey, newSeed);
        return newSeed;
      } catch (error) {
        if (!fallbackSeed) {
          fallbackSeed = Math.floor(Math.random() * 4294967296).toString(36);
        }
        return fallbackSeed;
      }
    }

    function getSortValue(productId, seed) {
      var value = seed + ':' + productId;
      var hash = 2166136261;
      for (var index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }
      return hash >>> 0;
    }

    function getProductId(item) {
      return item.dataset.randomizeProductId || item.dataset.freeGiftProductId || '';
    }

    function getItems(container) {
      return Array.from(container.children).filter(function (item) {
        return item.hasAttribute('data-randomize-product-id') || item.hasAttribute('data-free-gift-product-id');
      });
    }

    function shuffleSlider(container, items, seed) {
      var endMarker = Array.from(container.children).find(function (item) {
        return item.hasAttribute('data-free-gifts-randomize-end') || item.hasAttribute('data-randomize-products-end');
      });

      items.forEach(function (item) {
        container.insertBefore(item, endMarker || null);
      });
    }

    function shuffleCollectionGrid(container, items) {
      /*
       * Preserve featured/collage item positions by shuffling only the order slots
       * already assigned to product cards. Shopify pagination still determines which
       * products are loaded; each loaded result set is displayed in a stable random
       * order for the visitor's browser session.
       */
      var itemsByPage = {};
      items.forEach(function (item) {
        var page = item.dataset.page || '1';
        if (!itemsByPage[page]) itemsByPage[page] = [];
        itemsByPage[page].push(item);
      });

      Object.keys(itemsByPage).forEach(function (page) {
        var pageItems = itemsByPage[page];
        var orderSlots = pageItems.map(function (item) {
          var value = parseInt(item.style.order, 10);
          return Number.isFinite(value) ? value : 0;
        }).sort(function (a, b) { return a - b; });

        pageItems.forEach(function (item, index) {
          item.style.order = orderSlots[index];
        });
      });
    }

    function shuffleContainer(container) {
      if (container.hasAttribute('data-free-gifts-randomize')) {
        var giftCarousel = container.closest('component-carousel');
        if (giftCarousel && giftCarousel.initialized) {
          return;
        }
      }

      var seed = getSeed();
      var items = getItems(container);
      if (items.length < 2) return;

      items.sort(function (firstItem, secondItem) {
        var firstId = getProductId(firstItem);
        var secondId = getProductId(secondItem);
        var difference = getSortValue(firstId, seed) - getSortValue(secondId, seed);
        return difference || firstId.localeCompare(secondId);
      });

      if (container.hasAttribute('data-randomize-products')) {
        shuffleCollectionGrid(container, items);
      } else {
        shuffleSlider(container, items, seed);
      }
    }

    this.shuffle = function (root) {
      var scope = root || document;
      var selectors = '[data-free-gifts-randomize], [data-randomize-products]';
      if (scope.matches && scope.matches(selectors)) {
        shuffleContainer(scope);
      }
      scope.querySelectorAll(selectors).forEach(shuffleContainer);
    };

    function bindPageManagers(root) {
      root.querySelectorAll('[data-randomize-products]').forEach(function (container) {
        var pageManager = container.closest('page-manager');
        if (pageManager && !pageManager.dataset.productRandomizerBound) {
          pageManager.dataset.productRandomizerBound = 'true';
          pageManager.addEventListener('pageLoaded', function () {
            api.shuffle(pageManager);
          });
        }
      });
    }

    function initialize() {
      api.shuffle(document);
      bindPageManagers(document);

      if (document.body && !window.__swanProductRandomizerObserver) {
        window.__swanProductRandomizerObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (!(node instanceof Element)) return;
              if (node.matches('[data-randomize-products], page-manager') ||
                  node.querySelector('[data-randomize-products]')) {
                if (node.matches && node.matches('[data-randomize-products]')) {
                  shuffleContainer(node);
                }
                node.querySelectorAll('[data-randomize-products]').forEach(shuffleContainer);
                bindPageManagers(node);
              }
            });
          });
        });
        window.__swanProductRandomizerObserver.observe(document.body, {childList: true, subtree: true});
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  };
}
